import type { ComponentProps, ReactNode } from 'react';
import React from 'react';
import { StyledDetailedSummarySection } from './DealSummaryItem.style';
import { Typography } from '@interstate/components/Typography';
import { Grid } from '@interstate/components/Grid';
import LineItemRow from './LineItemRow';

interface DealSummaryDetailedViewProps {
    label: string;
    value: string;
    containerTestId: string;
    valueId: string;
    expandibleButtonStyles: ComponentProps<typeof Grid>['sx'];
    expandibleAreaStyles: ComponentProps<typeof Grid>['sx'];
    children: ReactNode;
    labelStyles?: ComponentProps<typeof Typography>['sx'];
    valueStyles?: ComponentProps<typeof Typography>['sx'];
    headerAction?: ReactNode;
}

const DealSummaryDetailedView: React.FC<DealSummaryDetailedViewProps> = ({
    label,
    value,
    containerTestId,
    valueId,
    expandibleButtonStyles,
    expandibleAreaStyles,
    children,
    labelStyles,
    valueStyles,
    headerAction
}) => {
    return (
        <>
            <StyledDetailedSummarySection hasExpandableButtonStyles={expandibleButtonStyles}>
                <LineItemRow
                    styles={{
                        pl: '1.857rem',
                        pb: '0.571rem',
                        pt: '0.571rem',
                        ...expandibleButtonStyles
                    }}
                >
                    <Typography
                        tag="span"
                        sx={{
                            flexGrow: 1,
                            ...labelStyles
                        }}
                        variant="body-xs"
                        color="sem.color.on-surface.muted"
                        data-testid={containerTestId}
                        className="summary-item-detail-label"
                    >
                        {label}
                    </Typography>
                    <Typography
                        tag="span"
                        variant="strong-sm"
                        color="sem.color.on-surface.default"
                        data-testid={valueId}
                        className="summary-item-detail-value"
                        sx={valueStyles}
                    >
                        {value}
                    </Typography>
                    {headerAction}
                </LineItemRow>
            </StyledDetailedSummarySection>
            <Grid
                sx={{
                    pb: 2,
                    pr: 2,
                    pl: '1.857rem',
                    ...expandibleAreaStyles
                }}
            >
                {children}
            </Grid>
        </>
    );
};

export default DealSummaryDetailedView;
